import "dayjs/locale/ar";
import "dayjs/locale/es";
import "dayjs/locale/fa";
import "dayjs/locale/fr";
import "dayjs/locale/he";
import "dayjs/locale/hy-am";
import "dayjs/locale/pt";
import "dayjs/locale/ru";
import "dayjs/locale/tr";
import "dayjs/locale/zh-cn";

export const DATE_LOCALE_BY_LANG = {
	en: "en",
	hy: "hy-am",
	ru: "ru",
	tr: "tr",
	ar: "ar",
	zh: "zh-cn",
	fa: "fa",
	he: "he",
	fr: "fr",
	es: "es",
	pt: "pt"
};

export function getDateLocale(lang) {
	return DATE_LOCALE_BY_LANG[lang] || "en";
}
